import { useState } from 'react'

import {
  EVENT_NAME_POINTER_CANCEL,
  EVENT_NAME_POINTER_UP,
} from '../../../../../constants/event'
import { useEventListener, useTimeZone } from '../../../../../hooks'

import {
  getCalendarGridWeekSelectionRange,
  getHasCalendarGridWeekSelectionRange,
  getIsCalendarGridWeekCellSelected,
  getIsCalendarGridWeekSelectionDay,
} from './useCalendarGridWeekSelection.utils'

export function useCalendarGridWeekSelection({ onSelectRange }) {
  const [selection, setSelection] = useState(null)

  const timezone = useTimeZone()

  function handlePointerUp() {
    setSelection(null)

    if (getHasCalendarGridWeekSelectionRange(selection)) {
      onSelectRange(getCalendarGridWeekSelectionRange({ selection, timezone }))
    }
  }

  function handlePointerCancel() {
    setSelection(null)
  }

  useEventListener({
    eventName: EVENT_NAME_POINTER_UP,
    handler: handlePointerUp,
  })

  useEventListener({
    eventName: EVENT_NAME_POINTER_CANCEL,
    handler: handlePointerCancel,
  })

  function handlePointerDownCell({ day, hour }) {
    if (onSelectRange) {
      setSelection({ anchorHour: hour, day, hour })
    }
  }

  function handlePointerEnterCell({ day, hour }) {
    setSelection(prevSelection =>
      getIsCalendarGridWeekSelectionDay({ day, selection: prevSelection })
        ? { ...prevSelection, hour }
        : prevSelection
    )
  }

  function getIsCellSelected({ day, hour }) {
    return getIsCalendarGridWeekCellSelected({ day, hour, selection })
  }

  return {
    getIsCellSelected,
    handlePointerDownCell,
    handlePointerEnterCell,
  }
}
